import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import Grid from "@mui/material/Grid";

import Label from "components/input/new/Label";
import CustomTooltip from "components/CustomTooltip";
import InfoTooltipIcon from "components/CustomTooltip/InfoTooltipIcon";

import LevelScoreBadge from "./components/LevelScoreBadge";
import LevelScoreContainer from "./components/LevelScoreContainer";
import DemandScore from "./components/DemandScore";

import {blue25, greyishBlue100} from "assets/jss/main";

ScoringSummary.propTypes = {
    scoring: PropTypes.object,
    demandScore: PropTypes.number,
    attractivenessScore: PropTypes.number,
    potentialImprovementScore: PropTypes.number,
    onOpenDrawer: PropTypes.func
};

function ScoringSummary({scoring, demandScore = 0, attractivenessScore = 0, potentialImprovementScore = 0, onOpenDrawer}) {
    return (
        <Grid item xs={12}>
            <Label
                htmlFor={''}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px'
                }}
            >
                <FormattedMessage id='retailer.product.scoring.form.summary.title' />
                <InfoTooltipIcon titleId={'retailer.product.scoring.form.summary.tooltip'} />
            </Label>
            <div style={{
                padding: '16px',
                background: blue25,
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                border: `1px solid ${greyishBlue100}`,
                borderRadius: '8px',
            }}>
                <LevelScoreContainer>
                    <DemandScore score={demandScore} />
                </LevelScoreContainer>
                <LevelScoreContainer>
                    <FormattedMessage id='retailer.product.scoring.form.summary.attractiveness.label' />
                    <LevelScoreBadge score={attractivenessScore} tooltipId={'retailer.product.scoring.form.summary.attractiveness.tooltip'} />
                </LevelScoreContainer>
                <LevelScoreContainer>
                    <FormattedMessage id='retailer.product.scoring.form.summary.potential.label' />
                    <CustomTooltip title={scoring ? <FormattedMessage id={'retailer.product.list.scoring.clickHint'}/> : ''}>
                        <span>
                            <LevelScoreBadge
                                onClick={onOpenDrawer}
                                score={potentialImprovementScore}
                                tooltipId={'retailer.product.scoring.form.summary.potential.tooltip'}
                            />
                        </span>
                    </CustomTooltip>
                </LevelScoreContainer>
            </div>
        </Grid>
    );
}

export default ScoringSummary;
